module.exports = __webpack_public_path__ + "img/flow_upload.c7950a20.png";